import React from 'react';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { Science } from '@mui/icons-material';
import { useDashboard } from '../../../contexts/DashboardContext';
const ExamsHub: React.FC = () => {
  const { updateContent, restorePreviousContent } = useDashboard();

  const handleStartMastitis = () => {
    updateContent('mastitisIntro');
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper
        elevation={0}
        sx={{
          maxWidth: 900,
          width: '100%',
          p: { xs: 2, md: 3 },
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
          <Science sx={{ color: '#8B5CF6' }} />
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Exames Laboratoriais
          </Typography>
          <Button variant="text" onClick={restorePreviousContent} sx={{ ml: 'auto' }}>
            Sair dos exames
          </Button>
        </Box>

        <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
          Selecione um exame para começar. Mais exames serão adicionados futuramente.
        </Typography>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mt: 1 }}>
          <Box>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Science sx={{ color: '#8B5CF6' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                  Análise de Mastite
                </Typography>
                <Chip label="Disponível" size="small" color="success" sx={{ ml: 'auto' }} />
              </Box>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Utilize imagem da placa de cultura e selecione colônias para obter uma análise assistida por IA.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <Button variant="contained" color="primary" onClick={handleStartMastitis}>
                  Iniciar
                </Button>
                <Button variant="outlined" color="inherit" onClick={restorePreviousContent}>
                  Sair dos exames
                </Button>
              </Box>
            </Paper>
          </Box>

          <Box>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                opacity: 0.6,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Science sx={{ color: 'text.secondary' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                  Em breve
                </Typography>
                <Chip label="Planejado" size="small" sx={{ ml: 'auto' }} />
              </Box>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Novos exames serão adicionados aqui conforme evoluímos a plataforma.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <Button variant="outlined" disabled>
                  Indisponível
                </Button>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default ExamsHub;
